export default {
  placeholder: 'Поиск...',
  minLengthHint: 'Для поиска необходимо минимум {{count}} символа',
};
